import { type RouteObject } from 'react-router'

import {
  FEEDBACK_DETAIL_TRANSACTION_PATH,
  FEEDBACK_DETAIL_URL,
  FEEDBACK_TRANSACTION_PATH,
  FEEDBACK_URL,
} from 'features/feedback/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const feedbackPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/feedback/Container'))

export const feedbackRoutes: RouteObject[] = [
  {
    path: FEEDBACK_URL,
    lazy: feedbackPage(),
    handle: {
      featureKey: FEEDBACK_URL,
      sentryTransactionPath: FEEDBACK_TRANSACTION_PATH,
    },
  },
  {
    path: `${FEEDBACK_URL}/:feedbackId`,
    lazy: feedbackPage(),
    handle: {
      featureKey: FEEDBACK_DETAIL_URL,
      sentryTransactionPath: FEEDBACK_DETAIL_TRANSACTION_PATH,
    },
  },
]
